var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5F5F79",
    fillRule: "evenodd",
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12c5.523 0 9-5 9-6s-3.477-6-9-6-9 5-9 6 3.477 6 9 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 2.25,
    stroke: "#FFF",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordEnabled);
export default __webpack_public_path__ + "static/media/show-password-enabled.33c955cddb8b69ca262a23b442478f25.svg";
export { ForwardRef as ReactComponent };